import React from "react";
import Pricing from "./Pricing";
import Hero from "./Hero";
import ProgramOverview from './ProgramOverview'
import Structure from './Structure'
import WhyProgramMatters from './WhyProgramMatters'
import Benefits from './Benefits'
import Enroll from './Enroll'
import Portfolio from './Portfolio'
import NewHero from "./NewHero";
import Bootcamp from '../Bootcamp'

const Program = () => {
    return (
        <div className="font-jost">
            <NewHero/>
            <Structure/>
            {/* <ProgramOverview/> */}
            {/* <WhyProgramMatters/> */}
            {/* <Benefits/> */}
            {/* <Pricing/> */}
            <Portfolio/>
            <Enroll/>
        </div>
    )
}

export default Program;